export default "__VITE_ASSET__BGdYUoE0__"